import { Utils } from './utils';
import { Forms } from './forms';
const formSelector = ".intermediary-portal-register-form";
const validationRules = {
    firstName: {
        required: true,
    },
    lastName: {
        required: true,
    },
    jobTitle: {
        required: true,
    },
    phone: {
        required: true,
        phone: true
    },
    email: {
        required: true,
        email: true
    },
    companyName: {
        required: true,
    },
    directorsName: {
        required: true,
    },
    directorsPhone: {
        required: true,
        phone: true
    },
    directorsEmail: {
        required: true,
        email: true
    },
    companyUrl: {
        required: true,
    },
    streetAddr1: {
        required: true,
    },
    city: {
        required: true,
    },
    postCode: {
        required: true,
        postcode: true
    },
    fcaAuthorised: {
        required: true,
    },
    isNetwork: {
        required: true,
    },
    isMortgageClub: {
        required: true,
    },
    affiliatedWithTradeBodies: {
        required: true,
    },
    currentCases: {
        required: true,
    },
    fcaRegistrationNumber: {
        required: true,
    },
    networkName: {
        required: true,
    },
    clubName: {
        required: true,
    },
    tradeBodyName: {
        required: true,
    },
    privacyPolicyAccepted: {
        required: true,
    },
    storageAccepted: {
        required: true,
    }
};
const validationMessages = {
    firstName: {
        required: "Please provide your first name",
    },
    lastName: {
        required: "Please provide your last name",
    },
    jobTitle: {
        required: "Please provide your job title",
    },
    phone: {
        required: "Please provide a phone number for contact purposes",
    },
    email: {
        required: "Please enter your email",
        email: "Please enter a valid email address",
    },
    companyName: {
        required: "Please provide a valid company name",
    },
    directorsName: {
        required: "Please provide the director's name of the company",
    },
    directorsPhone: {
        required: "Please provide a valid phone number for the director of your company",
    },
    directorsEmail: {
        required: "Please provide a valid email for the director of your company",
    },
    companyUrl: {
        required: "Please provide a link to your companies website",
    },
    streetAddr1: {
        required: "Please provide a street address for your company",
    },
    city: {
        required: "Please provide a city your company is based in",
    },
    postCode: {
        required: "Please provide a valid postcode",
        postcode: "Please provide the postcode in a valid format"
    },
    fcaAuthorised: {
        required: "Please indicate if you are directly authorised by the FCA",
    },
    isNetwork: {
        required: "Please indicate if you are a member of a Network",
    },
    isMortgageClub: {
        required: "Please indicate if you are a member of a Mortgage Club",
    },
    affiliatedWithTradeBodies: {
        required: "Please indicate if you are affiliated with any trade bodies",
    },
    currentCases: {
        required: "Please indicate if you have any current cases",
    },
    fcaRegistrationNumber: {
        required: "Please provide a valid FCA Registration Number",
    },
    networkName: {
        required: "Please provide your Network name",
    },
    clubName: {
        required: "Please provide your Mortgage Club name",
    },
    tradeBodyName: {
        required: "Please provide the trade body you are affiliated with",
    },
    privacyPolicyAccepted: {
        required: "Please accept our privacy policy",
    },
    storageAccepted: {
        required: "Please accept our terms of use",
    }
};
const intermediaryPortalRegisterForm = document.querySelector(formSelector);
let fcaRadios;
let networkRadios;
let clubRadios;
let tradeRadios;
let fcaLabel;
let fcaField;
let networkLabel;
let networkField;
let clubLabel;
let clubField;
let tradeLabel;
let tradeField;
function RadioShowField(button, field, showValue) {
    if (button.checked && button.value.toLowerCase() === showValue.toLowerCase()) {
        field.classList.add("visible");
        field.classList.remove("invisible");
    }
    else {
        field.classList.add("invisible");
        field.classList.remove("visible");
    }
}
/**
 * Initializes form validation and submission for the Intermeduary Registry form, with the GAEvent object configured for tracking.
 * @param formSelector The CSS selector for the form to be validated.
 * @param validationRules The validation rules to be applied to the form fields.
 * @param validationMessages The validation messages to be displayed for each field.
 */
function initializeFormValidation(formSelector, validationRules, validationMessages = undefined) {
    const { landingPage, conversionPagePath, gtmCode, spotCode, campaignName, campaignTerm, campaignMedium } = Utils.GetTrackingDataFromHiddenFields();
    let intermediaryPortalRegisterFormGAEvent = {
        event: 'intermediary-registry_submission',
        attributes: {
            landingPage: landingPage,
            conversionPagePath: conversionPagePath,
            gtmCode: gtmCode,
            source: spotCode,
            campaignName: campaignName,
            campaignTerm: campaignTerm,
            campaignMedium: campaignMedium,
        }
    };
    Forms.initializeFormValidation(formSelector, validationRules, validationMessages, intermediaryPortalRegisterFormGAEvent);
}
/**
 * Initializes form validation and submission for the IntermediaryRegister Now form, if
 * one is present on the form. Successful submission results in a redirect to a thank you
 * page, since we validate server side the only failure mode is recapture failure.
 */
window.addEventListener("load", () => {
    initializeFormValidation(formSelector, validationRules, validationMessages);
    if (intermediaryPortalRegisterForm !== null) {
        fcaRadios = intermediaryPortalRegisterForm.querySelectorAll("input[name='fcaAuthorised']");
        networkRadios = intermediaryPortalRegisterForm.querySelectorAll("input[name='isNetwork']");
        clubRadios = intermediaryPortalRegisterForm.querySelectorAll("input[name='isMortgageClub']");
        tradeRadios = intermediaryPortalRegisterForm.querySelectorAll("input[name='affiliatedWithTradeBodies']");
        fcaLabel = intermediaryPortalRegisterForm.querySelector("label[for='fcaRegistrationNumber']");
        fcaField = intermediaryPortalRegisterForm.querySelector("input[name='fcaRegistrationNumber']");
        networkLabel = intermediaryPortalRegisterForm.querySelector("label[for='networkName']");
        networkField = intermediaryPortalRegisterForm.querySelector("input[name='networkName']");
        clubLabel = intermediaryPortalRegisterForm.querySelector("label[for='clubName']");
        clubField = intermediaryPortalRegisterForm.querySelector("input[name='clubName']");
        tradeLabel = intermediaryPortalRegisterForm.querySelector("label[for='tradeBodyName']");
        tradeField = intermediaryPortalRegisterForm.querySelector("input[name='tradeBodyName']");
        fcaRadios.forEach((button) => {
            RadioShowField(button, fcaField, "yes");
            RadioShowField(button, fcaLabel, "yes");
            button.addEventListener("click", () => {
                RadioShowField(button, fcaField, "yes");
                RadioShowField(button, fcaLabel, "yes");
            });
        });
        networkRadios.forEach((button) => {
            RadioShowField(button, networkField, "yes");
            RadioShowField(button, networkLabel, "yes");
            button.addEventListener("click", () => {
                RadioShowField(button, networkField, "yes");
                RadioShowField(button, networkLabel, "yes");
            });
        });
        clubRadios.forEach((button) => {
            RadioShowField(button, clubField, "yes");
            RadioShowField(button, clubLabel, "yes");
            button.addEventListener("click", () => {
                RadioShowField(button, clubField, "yes");
                RadioShowField(button, clubLabel, "yes");
            });
        });
        tradeRadios.forEach((button) => {
            RadioShowField(button, tradeField, "yes");
            RadioShowField(button, tradeLabel, "yes");
            button.addEventListener("click", () => {
                RadioShowField(button, tradeField, "yes");
                RadioShowField(button, tradeLabel, "yes");
            });
        });
    }
});
